import React, { useMemo } from "react";

import { makeStyles } from "tss-react/mui";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { BigTile, TextComponent } from "../../../../Common/Tile";

const useStyles = makeStyles()((theme) => ({
  NoData: {
    display: "flex",
    justifyContent: "center",
  },
}));

function Tile({ loading, entities, navigateToDashboard }) {
  const { classes } = useStyles();

  const $sortedEntities = useMemo(
    () => [...entities.sort((a, b) => a["displayName"].localeCompare(b["displayName"]))],
    [entities]
  );

  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      <Grid sx={{ mb: 1, display: "flex", alignItems: "center" }} size={12}>
        <Box sx={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
          <Grid container spacing={4} direction="row">
            {!loading &&
              entities.length > 0 &&
              $sortedEntities.map(({ id, name, displayName, description, fieldCount }) => (
                <Grid
                  key={id}
                  sx={{ mb: 2 }}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    xl: 3
                  }}>
                  <BigTile
                    configData={{
                      dataId: "ent" + name,
                      clickEvent: () => navigateToDashboard({ Object_id: id }),
                      cursor: "pointer",
                      icon: <img src="/images/columns.png" alt="Entities" />,
                      iconClass: "BottomIcon",
                      borderLeft: "10px solid #CDE4F0",
                      label: displayName || name,
                      description: <TextComponent label="" value={description} paragraph={true} />,
                      totalFields: <TextComponent label="Total Fields" value={fieldCount} />,
                      textTransform: "none",
                    }}
                  />
                </Grid>
              ))}

            {!loading && entities.length === 0 && (
              <Grid sx={{ mb: 2, mt: 5 }} className={classes.NoData} size={12}>
                <Typography variant="h6" color={"error"} style={{ color: "#000000d9" }} textTransform="none">
                  No records found
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Tile;
